import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import AlternateDashboardCtaCard from ".";
import Translate from "translate/Translate";
import { selectExistingOrdersWithoutCancelled } from "store/reducers/order/OrderInformationSlice";
import { selectAllPreviousSurveyAnswers } from "store/reducers/survey/SurveySlice";
import { flattenSurveyAnswers } from "utils/v3/surveyUtils";

const CancerDashboardAlternateCtaCard = () => {
  const history = useHistory();
  const kitsAlreadyOrdered = useSelector(selectExistingOrdersWithoutCancelled);
  const previousSurveyAnswers = useSelector(selectAllPreviousSurveyAnswers);
  const flattenedSurveyAnswers = flattenSurveyAnswers(previousSurveyAnswers);

  // Check if member has ordered at least one test
  const hasOrderedAtLeastOneTest = kitsAlreadyOrdered.length > 0;

  // Check if member has reported cancer before
  // Note: basal-cell-or-squamous-cell-skin-cancer does NOT count as reported cancer
  const hasReportedCancer =
    flattenedSurveyAnswers["active-cancer-diagnosis"] === true ||
    (flattenedSurveyAnswers["have-you-ever-been-told-you-have-cancer"] ===
      true &&
      flattenedSurveyAnswers["cancer-type"] !==
        "basal-cell-or-squamous-cell-skin-cancer") ||
    (flattenedSurveyAnswers["which-cancer-status-best-applies-to-you"] !==
      undefined &&
      flattenedSurveyAnswers["cancer-type"] !==
        "basal-cell-or-squamous-cell-skin-cancer");

  // Only show card if member has ordered at least one test AND has not reported cancer
  if (!hasOrderedAtLeastOneTest || hasReportedCancer) {
    return null;
  }

  return (
    <AlternateDashboardCtaCard
      header={<Translate text={"Are you currently dealing with cancer?"} />}
      subheader={
        <Translate
          text={"We have a dedicated team to help support your journey."}
        />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "cancer_survey",
            ctaLocation: "dashboard_card",
            ctaId: "cancer_survey"
          });

          history.push(PATHS.CANCER_SURVEY);
        },
        overrideClick: false,
        text: "Please let us know",
        url: PATHS.CANCER_SURVEY,
        buttonId: "cancer-survey-cta"
      }}
    />
  );
};

export default CancerDashboardAlternateCtaCard;
